import { render, staticRenderFns } from "./ClassActions.vue?vue&type=template&id=595c22dd&scoped=true"
import script from "./ClassActions.vue?vue&type=script&lang=js"
export * from "./ClassActions.vue?vue&type=script&lang=js"
import style0 from "./ClassActions.vue?vue&type=style&index=0&id=595c22dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595c22dd",
  null
  
)

export default component.exports